import React, { useState } from 'react';

const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    if (openFaq === index) {
      setOpenFaq(null);
    } else {
      setOpenFaq(index);
    }
  };

  const faqs = [
    {
      question: "What launch monitors are compatible with RangeDat?",
      answer: "RangeDat is compatible with all major launch monitors including Trackman, GC Quad, Flightscope, SkyTrak, Garmin R10, Rapsodo MLM, and more. As long as your launch monitor can export data in CSV, Excel, or JSON format, you can import it into RangeDat for analysis."
    },
    {
      question: "Do I need a subscription to export data from my launch monitor?",
      answer: "This depends on your launch monitor. Some devices like Trackman and GC Quad include data export with all subscription levels, while others like Rapsodo may require a premium subscription for certain export features. Check your launch monitor's documentation or our specific export guides for details."
    },
    {
      question: "How often should I export my data?",
      answer: "We recommend exporting your data after each practice session for the most comprehensive tracking. However, you can export data at any frequency that works for you. Just remember that some launch monitors only store a limited number of sessions, so regular exports ensure you don't lose valuable data."
    },
    {
      question: "Can I import data from multiple launch monitors?",
      answer: "Yes! RangeDat is designed to handle data from multiple launch monitors. Our system normalizes data from different sources to provide consistent analysis. You can filter and compare data across different launch monitors in your analytics views."
    },
    {
      question: "What if my launch monitor doesn't provide all the data fields?",
      answer: "RangeDat works with whatever data is available. While more data fields provide more detailed analysis, you can still get valuable insights from basic metrics like ball speed and distance. Our system will adapt the available visualizations and insights based on the data you provide."
    },
    {
      question: "Can I manually enter shot data?",
      answer: "Yes, RangeDat allows manual data entry for shots. This is useful if you're using a basic launch monitor that doesn't export data, or if you want to record on-course shots. You can enter key metrics like club, distance, and accuracy through our manual entry form."
    },
    {
      question: "How do I handle data from different environments (indoor vs. outdoor)?",
      answer: "RangeDat allows you to tag sessions with environment information. You can specify indoor or outdoor settings, altitude, temperature, and other conditions. Our analytics can then account for these differences when comparing data across sessions."
    },
    {
      question: "What file size limits apply to imports?",
      answer: "Standard accounts can import files up to 10MB in size. Premium accounts can import files up to 50MB. If your file exceeds these limits, try splitting it into multiple sessions or contact support for assistance with large imports."
    },
    {
      question: "Can I export my analyzed data from RangeDat?",
      answer: "Yes, you can export your analyzed data, charts, and insights from RangeDat in various formats including PDF reports, CSV data exports, and image files of your visualizations. Premium accounts have additional export options including branded reports and presentation-ready graphics."
    },
    {
      question: "How secure is my data in RangeDat?",
      answer: "Your data security is our priority. All data is encrypted during transfer and storage. Your shot data is private by default and only visible to you. You can optionally share specific sessions or insights with coaches or friends through secure, controlled sharing features."
    },
    {
      question: "What if the date/time in my export file is incorrect?",
      answer: "During import, RangeDat allows you to review and adjust session dates and times. If your export contains incorrect timestamps, you can correct them during the import process or edit the session details after import."
    },
    {
      question: "Can I delete or edit shots after import?",
      answer: "Yes, you can edit or delete individual shots after import. This is useful for removing outliers or correcting data entry errors. You can also add notes to specific shots to record observations about your swing or conditions."
    }
  ];

  return (
    <div className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <p className="section-intro">
        Find answers to common questions about importing and exporting data with RangeDat.
      </p>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-item ${openFaq === index ? 'open' : ''}`}
          >
            <div 
              className="faq-question" 
              onClick={() => toggleFaq(index)}
            >
              <h4>{faq.question}</h4>
              <span className="faq-toggle">{openFaq === index ? '−' : '+'}</span>
            </div>
            {openFaq === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="faq-contact">
        <h3>Can't find what you're looking for?</h3>
        <p>
          If you have a question that's not covered here, please contact our support team.
        </p>
        <a href="mailto:support@rangedat.com" className="contact-button">
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default FAQSection;
